export default __webpack_public_path__ + "static/media/7.dd15b5c7.svg";